/* ============================================================
   PATCHPOP — Hero Playground (shared patches)
   assets/patch-pop-hero-playground.js

   Patches are shared/global. Switching the base (Cap <-> T-Shirt)
   keeps the same selected patch via a single sharedIndex.
   ============================================================ */
(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.ppInit === '1') return;
    root.dataset.ppInit = '1';

    var defaultBase = root.dataset.defaultBase || '';
    if (!defaultBase) return;

    var tabs     = Array.prototype.slice.call(root.querySelectorAll('[data-pp-tab]'));
    var bases    = Array.prototype.slice.call(root.querySelectorAll('[data-pp-base]'));
    var rail     = root.querySelector('[data-pp-rail]');
    var allCards = Array.prototype.slice.call(root.querySelectorAll('[data-pp-patch]'));
    var prevBtn  = root.querySelector('[data-pp-prev]');
    var nextBtn  = root.querySelector('[data-pp-next]');
    var nameEl   = root.querySelector('[data-pp-active-name]');
    var product  = root.querySelector('[data-pp-product]');

    var state = {
      base:        defaultBase,
      sharedIndex: 0
    };

    /* All patch cards are global — no per-base filtering */
    function patches() { return allCards; }

    function setBase(base, opts) {
      opts = opts || {};
      if (!patches().length) return;

      state.base = base;

      tabs.forEach(function (tab) {
        var active = tab.dataset.ppTab === base;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      bases.forEach(function (baseEl) {
        baseEl.classList.toggle('is-active', baseEl.dataset.ppBase === base);
      });

      /* Reapply the currently-selected patch on the newly active base */
      applyPatch(state.sharedIndex || 0, opts.instant === true);
    }

    function applyPatch(index, instant) {
      var list = patches();
      if (!list.length) {
        if (nameEl) nameEl.textContent = '';
        return;
      }

      if (index < 0) index = list.length - 1;
      if (index >= list.length) index = 0;
      state.sharedIndex = index;

      var card       = list[index];
      var overlayUrl = card.dataset.overlay || '';
      var baseEl     = root.querySelector('[data-pp-base="' + state.base + '"]');
      if (!baseEl) return;

      var overlayEl  = baseEl.querySelector('[data-pp-overlay]');
      if (!overlayEl) return;

      var overlayImg = overlayEl.querySelector('[data-pp-overlay-img]');
      if (!overlayImg) return;

      allCards.forEach(function (cardItem) {
        var active = cardItem === card;
        cardItem.classList.toggle('is-active', active);
        cardItem.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      function paintOverlay() {
        if (overlayUrl) {
          overlayImg.src = overlayUrl;
          overlayImg.removeAttribute('hidden');
        } else {
          overlayImg.removeAttribute('src');
          overlayImg.setAttribute('hidden', '');
        }

        /* Force reflow so the transition re-fires */
        /* eslint-disable-next-line no-unused-expressions */
        overlayEl.offsetWidth;
        overlayEl.classList.remove('is-snap');
        overlayEl.classList.toggle('is-in', Boolean(overlayUrl));
      }

      if (instant) {
        overlayEl.classList.remove('is-snap', 'is-in');
        paintOverlay();
      } else {
        overlayEl.classList.remove('is-in');
        overlayEl.classList.add('is-snap');
        window.setTimeout(paintOverlay, 160);
      }

      if (nameEl) nameEl.textContent = card.dataset.name || '';

      if (rail && card.offsetParent !== null) {
        var targetLeft = card.offsetLeft - (rail.clientWidth / 2) + (card.offsetWidth / 2);
        rail.scrollTo({ left: targetLeft, behavior: instant ? 'auto' : 'smooth' });
      }
    }

    /* ---- Events ---- */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.disabled || tab.classList.contains('is-disabled')) return;
        setBase(tab.dataset.ppTab);
      });
    });

    allCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var list  = patches();
        var index = list.indexOf(card);
        if (index >= 0) applyPatch(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        applyPatch((state.sharedIndex || 0) - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        applyPatch((state.sharedIndex || 0) + 1);
      });
    }

    if (rail) {
      rail.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          applyPatch((state.sharedIndex || 0) - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          applyPatch((state.sharedIndex || 0) + 1);
        }
      });
    }

    if (product) {
      var touchStartX = 0;
      var touchDeltaX = 0;
      var isTouching  = false;

      product.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        isTouching  = true;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      product.addEventListener('touchmove', function (event) {
        if (!isTouching || !event.touches || !event.touches.length) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      product.addEventListener('touchend', function () {
        if (!isTouching) return;
        isTouching = false;
        if (Math.abs(touchDeltaX) > 40) {
          applyPatch((state.sharedIndex || 0) + (touchDeltaX < 0 ? 1 : -1));
        }
      });
    }

    setBase(state.base, { instant: true });
  }

  function initAll() {
    document.querySelectorAll('[data-pp-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector
      ? event.target.querySelector('[data-pp-hero]')
      : null;
    if (!hero && event.target.matches && event.target.matches('[data-pp-hero]')) {
      hero = event.target;
    }
    if (hero) {
      hero.dataset.ppInit = '';
      initHero(hero);
    }
  });
}());
